import React from 'react';
import { useParams } from 'react-router-dom';
import { usePsChat } from '../../context/PsChatMessageContext';
import { useUserId, useUserRole } from '../../util_functions/helpers';
import JitsiMeeting from './JitsiMeeting';

const MeetingComponent = () => {
  const {preferredMethod, sessionName, threadId } = useParams();
  const { state } = usePsChat();
  const thread = state.messages.find(t => t.id === threadId) || {};
  const userId       = useUserId();
  const userRole     = useUserRole();
  const displayName  = userRole === 'worker' ? thread.worker : thread.client;

  return (
    <div className="meeting-body">
      <JitsiMeeting
        roomName={sessionName}
        displayName={displayName}
        userId={userId}
        userName={displayName}
        userRole={userRole}
        sessionName={sessionName}
        threadId={threadId}
        preferredMethod={preferredMethod}
      />
    </div>
  );
};

export default MeetingComponent;


